"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAblyTokenResponseDto = instanceOfAblyTokenResponseDto;
exports.AblyTokenResponseDtoFromJSON = AblyTokenResponseDtoFromJSON;
exports.AblyTokenResponseDtoFromJSONTyped = AblyTokenResponseDtoFromJSONTyped;
exports.AblyTokenResponseDtoToJSON = AblyTokenResponseDtoToJSON;
exports.AblyTokenResponseDtoToJSONTyped = AblyTokenResponseDtoToJSONTyped;
var AblyTokenDto_1 = require("./AblyTokenDto");
/**
 * Check if a given object implements the AblyTokenResponseDto interface.
 */
function instanceOfAblyTokenResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function AblyTokenResponseDtoFromJSON(json) {
    return AblyTokenResponseDtoFromJSONTyped(json, false);
}
function AblyTokenResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, AblyTokenDto_1.AblyTokenDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function AblyTokenResponseDtoToJSON(json) {
    return AblyTokenResponseDtoToJSONTyped(json, false);
}
function AblyTokenResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, AblyTokenDto_1.AblyTokenDtoToJSON)(value['data']),
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
